import { Formik } from "formik";
import { Modal } from "rsuite";
import { Button } from "../../../components";
import * as Yup from "yup";
import { getLocalized } from "../../../redux/localization";
import { useDispatch, useSelector } from "react-redux";
import "../style.scss";
import {
  Customer,
  Offer,
  OfferRevision,
  OfferRevisionCar,
} from "../../../redux/offer/types";
import { GarageCartItem } from "../../../redux/garageCart/type";
import { useState } from "react";
import KVKK from "./kvk";
import { CheckBox } from "devextreme-react";
import {
  createCustomer,
  createOffer,
  createOfferRevision,
  sendWelcomeEmail,
} from "../../../redux/offer";
import { generateNumber } from "../../../helpers/guid";
import moment from "moment";
import CustomInput from "../../../components/input";
import { Col, Row } from "reactstrap";
import { ButtonType } from "../../../components/button";
import CustomLoader from "../../../components/loader";
import { AiOutlineArrowRight } from "react-icons/ai";

const OfferAccept = ({
  data,
  customer,
  visible,
  handleClose,
  buttonClick,
}: {
  data: GarageCartItem[];
  customer: Customer;
  visible: boolean;
  handleClose: () => void;
  buttonClick: (id?: string) => void;
}) => {
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();
  const localize = useSelector(getLocalized);
  const [showTerm, setShowTerm] = useState(false);
  const validationSchema = Yup.object({
    CompanyName: Yup.string().required(localize.getString("required")),
    Name: Yup.string().required(localize.getString("required")),
    Surname: Yup.string().required(localize.getString("required")),
    // TaxOffice: Yup.string().required(localize.getString("required")),
    // TaxNumber: Yup.string().required(localize.getString("required")),
    Phone: Yup.string()
      .required(localize.getString("required"))
      .test(
        "len",
        localize.getString("phonelenght"),
        (val) => val?.toString().length === 10
      )
      .test("startwith", (val) => {
        let check = val?.startsWith("0") ? false : true;
        console.log(val?.startsWith("0"));
        return check ? check : true;
      }),
    Email: Yup.string()
      .required(localize.getString("required"))
      .email(localize.getString("emailerror")),
    Approved: Yup.boolean().oneOf([true], localize.getString("accepterror")),
  });

  const handleSubmitOffer = ({ customerId }: { customerId?: string }) => {
    const carArray: OfferRevisionCar[] = [];
    data?.map((offerCar) => {
      let carRevision: OfferRevisionCar = {
        CarId: offerCar.Car?.Id,
        KMLimitId: offerCar.Price?.KMLimitId,
        PeriodId: offerCar.Price?.PeriodId,
        PeriodPrice: offerCar.Price?.PricePerMonth,
        Quantity: offerCar.Count,
      };
      return carArray.push(carRevision);
    });

    const date = new Date();
    date.setDate(date.getDate() + 7);
    const offerRevision: OfferRevision = {
      OfferNumber: generateNumber(),
      ValidUntil: moment(date, "DD-MM-YYYY").format(),
      // CreatedOfferFile: pdf,
      StatusId: "fb873a82-f9fe-4674-bb75-b8fa537eade0",
      OfferCars: carArray,
    };
    const offer: Offer = {
      CustomerId: customerId,
      OfferTypeId: "5ce24860-ea0f-4ea8-b6a2-2d30370a7818",
      DocumentsDemanded: false,
      SignContractDemanded: false,
      StatusId: "fb873a82-f9fe-4674-bb75-b8fa537eade0",
    };
    dispatch(
      createOffer({
        payload: {
          onSuccess: (message, payload) => {
            offerRevision.OfferId = payload.Id;
            const id = payload.Id;
            dispatch(
              createOfferRevision({
                payload: {
                  onSuccess: (message, payload) => {
                    dispatch(
                      sendWelcomeEmail({
                        payload: {
                          onSuccess: (message, payload) => {
                            buttonClick(id);
                          },
                          onError: (message) => {},
                        },
                        url: "api/offer/sendwelcomeemail/" + id,
                      })
                    );
                  },
                  onError: (message) => {},
                },
                url: "api/offer/revision",
                body: offerRevision,
              })
            );
          },
          onError: (message) => {},
        },
        url: "api/offer",
        body: offer,
      })
    );
  };

  const submitForm = (values: any) => {
    setLoader(true);
    dispatch(
      createCustomer({
        payload: {
          onSuccess: (message, payload) => {
            customer.Id = payload.Id;
            handleSubmitOffer({ customerId: customer.Id });
          },
          onError: (message) => {},
        },
        url: "api/customer/create/customer",
        body: values,
      })
    );
  };

  return (
    <Modal
      className="offer-modal"
      open={visible}
      onClose={handleClose}
      size="xs"
    >
      <Modal.Header
        className="header-font"
        style={{
          paddingBlock: 20,
          textAlign: "center",
        }}
      >
        {localize.getString("createofferform")}
      </Modal.Header>

      <div>
        <Modal.Body style={{ overflowX: "hidden", paddingInlineStart: 30 }}>
          {loader && <CustomLoader />}
          <Formik
            initialValues={customer}
            onSubmit={submitForm}
            validationSchema={validationSchema}
          >
            {({ handleSubmit, setFieldValue, values, errors, touched }) => {
              return (
                <div className="w-100">
                  <Row className="w-100">
                    <Col>
                      <CustomInput
                        value={values.CompanyName}
                        error={errors.CompanyName}
                        label={localize.getString("companyName")}
                        onChanged={(e) => setFieldValue("CompanyName", e)}
                      />
                    </Col>
                  </Row>

                  <Row className="w-100">
                    <Col md={6}>
                      <CustomInput
                        value={values.Name}
                        error={errors.Name}
                        label={localize.getString("name")}
                        onChanged={(e) => setFieldValue("Name", e)}
                      />
                    </Col>
                    <Col md={6}>
                      <CustomInput
                        value={values.Surname}
                        error={errors.Surname}
                        label={localize.getString("surname")}
                        onChanged={(e) => setFieldValue("Surname", e)}
                      />
                    </Col>
                  </Row>
                  {/* <Row className="w-100">
                    <Col md={6}>
                      <CustomInput
                        value={values.TaxOffice}
                        error={errors.TaxOffice}
                        label={localize.getString("taxOffice")}
                        onChanged={(e) => setFieldValue("TaxOffice", e)}
                      />
                    </Col>
                    <Col md={6}>
                      <CustomInput
                        type={"number"}
                        value={values.TaxNumber}
                        error={errors.TaxNumber}
                        label={localize.getString("taxNumber")}
                        onChanged={(e) =>
                          e.length < 11 && setFieldValue("TaxNumber", e)
                        }
                      />
                    </Col>
                  </Row> */}
                  <Row className="w-100">
                    <Col md={6}>
                      <CustomInput
                        type={"number"}
                        showError
                        value={values.Phone}
                        error={errors.Phone}
                        label={localize.getString("phone")}
                        onChanged={(e) =>
                          e.length <= 10 && setFieldValue("Phone", e)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <CustomInput
                        error={errors.Email}
                        value={values.Email}
                        label={localize.getString("email")}
                        onChanged={(e) => setFieldValue("Email", e)}
                      />
                    </Col>
                  </Row>
                  <div>
                    <div>
                      <CheckBox
                        name="Approved"
                        className="checkbox"
                        value={values.Approved}
                        onValueChanged={(e: any) =>
                          setFieldValue("Approved", e.value)
                        }
                      />
                      <label
                        className="Modaltext"
                        style={{ marginBlockStart: 18, marginInlineStart: 10 }}
                      >
                        <span
                          onClick={() => setShowTerm(true)}
                          style={{ cursor: "pointer", color: "#ff4436" }}
                        >
                          KVKK
                        </span>{" "}
                        Sözleşme Onayı
                      </label>
                      <p className="errors Modaltext">{errors.Approved}</p>
                      <Modal
                        className="offer-modal"
                        open={showTerm}
                        onClose={() => setShowTerm(false)}
                        size="lg"
                      >
                        <Modal.Header
                          onClose={() => setShowTerm(false)}
                        ></Modal.Header>
                        <div>
                          <KVKK />
                        </div>
                      </Modal>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      customClassName="btnGarajTamamla"
                      type="submit"
                      style={{
                        width: "max-content",
                        marginInlineEnd: 20,
                        fontSize: 24,
                        fontWeight: 700,
                      }}
                      icon={<AiOutlineArrowRight></AiOutlineArrowRight>}
                      buttonType={ButtonType.newColored}
                      title={localize.getString("makeofferstep1")}
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              );
            }}
          </Formik>
        </Modal.Body>
      </div>
    </Modal>
  );
};
export default OfferAccept;
